import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Save as SaveIcon, Cancel as CancelIcon } from "@material-ui/icons";
import { Modal } from "src/components";
import { cadastrarUsuario } from "src/store/actions/usuarios";

const USUARIO_SCHEMA = {
  nome: "",
  email: "",
  password: "",
};

function ModalUsuario({ open, close }) {
  const [formUsuario, setFormUsuario] = useState(USUARIO_SCHEMA);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) {
      setFormUsuario(USUARIO_SCHEMA);
      setError("");
    }
  }, [open]);

  const handleChange = (event) => {
    setFormUsuario({
      ...formUsuario,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = () => {
    cadastrarUsuario(formUsuario)
      .then(() => {
        close();
      })
      .catch((error) => {
        setError(error.response.data.error);
      });
  };

  return (
    <Modal open={open}>
      <Typography> Adicionar novo Usuário </Typography>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid style={{ marginTop: "8px" }} container spacing={1}>
          <Grid item sm={12}>
            <TextValidator
              fullWidth
              variant="outlined"
              name="nome"
              label="Nome"
              value={formUsuario.nome}
              onChange={handleChange}
              validators={["required"]}
              errorMessages={["Campo obrigatório"]}
            />
          </Grid>
          <Grid item sm={12}>
            <TextValidator
              error={Boolean(error)}
              fullWidth
              variant="outlined"
              name="email"
              label="Email"
              value={formUsuario.email}
              onChange={handleChange}
              validators={["required", "isEmail"]}
              errorMessages={["Campo obrigatório", "E-mail inválido"]}
              helperText={error}
            />
          </Grid>
          <Grid item sm={12}>
            <TextValidator
              fullWidth
              variant="outlined"
              name="password"
              label="Senha"
              type="password"
              value={formUsuario.password}
              onChange={handleChange}
              validators={[
                "required",
                // "matchRegexp:^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",
              ]}
              errorMessages={[
                "Campo obrigatório",
                // "Morra flamenguista desgraçado",
              ]}
            />
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="flex-end">
          <Button color="primary" size="small" type="submit">
            <SaveIcon />
            &nbsp;Gravar
          </Button>
          <Button color="secondary" size="small" onClick={close}>
            <CancelIcon />
            &nbsp;Cancelar
          </Button>
        </Box>
      </ValidatorForm>
    </Modal>
  );
}

export default ModalUsuario;
